/**
 * Supabase Client — 单例初始化
 *
 * 环境变量:
 *   VITE_SUPABASE_URL
 *   VITE_SUPABASE_ANON_KEY
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
import { createLogger } from '@/shared/utils/logger';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  // In development, fall back to local Supabase; in production, this is a fatal config error
  const isDev = import.meta.env.DEV;
  if (!isDev) {
    throw new Error(
      '[NovelStudio] FATAL: Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in production build. ' +
      'Set them in your environment before building.',
    );
  }
  createLogger('Supabase').warn('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Falling back to localhost. Set them in .env.local for production.');
}

export const supabase: SupabaseClient<Database> = createClient<Database>(
  supabaseUrl ?? 'http://localhost:54321',
  supabaseAnonKey ?? 'placeholder',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  },
);

export type TypedSupabaseClient = typeof supabase;

// Expose for E2E testing (quality verification scripts query DB via globalThis)
if (typeof globalThis !== 'undefined') {
  (globalThis as Record<string, unknown>).__supabase = supabase;
}
